import { ApiError } from "./api.js";

interface AccessSubscription { id: string; status: string; expiresAt: string }

// A customer account remains usable when its VPN access has ended.
export async function loadSubscriptionAccess<S extends AccessSubscription, B, D>(
  subscriptions: S[],
  loadBundle: (id: string) => Promise<{ bundle: B }>,
  loadDevices: (id: string) => Promise<{ devices: D[] }>,
  now = Date.now(),
): Promise<{ subscription: S | null; bundle: B | null; devices: D[] }> {
  const inactive = { subscription: null, bundle: null, devices: [] };
  const subscription = subscriptions.find((item) =>
    item.status === "ACTIVE" && new Date(item.expiresAt).getTime() > now);
  if (!subscription) return inactive;

  let bundle: B;
  try {
    ({ bundle } = await loadBundle(subscription.id));
  } catch (cause) {
    // Access can expire between the list request and the connection request.
    if (cause instanceof ApiError && cause.status === 403 &&
        (cause.code === "EXPIRED" || cause.code === "NOT_ACTIVE")) return inactive;
    throw cause;
  }
  const { devices } = await loadDevices(subscription.id);
  return { subscription, bundle, devices };
}
